<template>
  <v-card>
    <v-file-input
      outlined
      dense
      accept=".xml"
      label="Choose Config File"
    ></v-file-input>
  </v-card>
</template>

<script>

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

export default {
  name: 'FileUpload',
  mixins: [deviceConfigMixin]
}
</script>

<style lang="scss" scoped>

</style>